import axiosInstance from '../../../../config/axiosInstance';
const  EmailingService = {
    async GetEmailSetting(redirectCallback) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetEmailingSetting?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    } ,
    async UpdateEmailStatus(redirectCallback,SettingsValue_ID, status) {
        try {           
            const formData = {
                SettingsValue_ID: SettingsValue_ID,
                status: status
            };            
            const response = await axiosInstance.post(`/Setup/UpdateEmailStatus`, formData);
            
        } catch (error) {
            if (error.response.data.message === "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error updating email status:', error);
            throw error;
        }
    }
};

export default EmailingService;